module.exports = __webpack_public_path__ + "img/Fond_Carte_Mini_Feu.b46365a0.png";